import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  get_candidate_job_offer_details_action,
  update_candidate_job_offer_action,
} from "../../../redux/_actions/candidate";

function useAssignedJobOfferTerms() {
  const params = useParams();

  const [jobOfferTerms, setJobOfferTerms] = useState({});
  const [loading, setLoading] = useState(false);
  const [loadingError, setLoadingError] = useState();
  const [acceptLoading, setAcceptLoading] = useState(false);
  const [isDeclineOfferModal, setIsDeclineOfferModal] = useState(false);


  const dispatch = useDispatch();

  const { candidateJobOfferDetailsData } = useSelector(
    (state) => state.get_candidate_job_offer_details_reducer
  );

  useEffect(() => {
    let id = params?.jobId;
    if (id) {
      callApi(id);
    } else {
      setLoadingError("Unable to find the assessment kit you are looking for.");
    }
  }, []);

  useEffect(() => {
    if (candidateJobOfferDetailsData?.data) {
      setJobOfferTerms(candidateJobOfferDetailsData?.data);
    }
  }, [candidateJobOfferDetailsData]);

  const callApi = async (id) => {
    setLoading(true);
    if (id) {
      await dispatch(get_candidate_job_offer_details_action(id));
    }
    setLoading(false);
  };

  const onAcceptJobOfferTermsClick = async (is_accepted) => {
    setAcceptLoading(true);
    const data = is_accepted
      ? { offer_accepted: is_accepted }
      : { offer_rejected: !is_accepted };
    if (jobOfferTerms?.id)
      await dispatch(
        update_candidate_job_offer_action(jobOfferTerms?.candidate_job_application,
          data,
        )
      );
    setAcceptLoading(false);
    setIsDeclineOfferModal(false);
  };

  const handleIsDeclineOfferModal = () => {
    setIsDeclineOfferModal(!isDeclineOfferModal);

  }

  return {
    loading,
    loadingError,
    jobOfferTerms,
    acceptLoading,
    isDeclineOfferModal,
    onAcceptJobOfferTermsClick,
    handleIsDeclineOfferModal
  };
}

export default useAssignedJobOfferTerms;
